module.exports = __webpack_public_path__ + "img/nz.c35868e6.svg";